<template>
  <!-- <vk-modal :show.sync="showed" :stuck="true" overflow-auto size="container" :center="true" :stack="true">
    <vk-modal-close @click="showed = false"></vk-modal-close>
    <vk-modal-title slot="header">{{title}}</vk-modal-title>
    <component :is="сurrentForm" :payload="currentFormData" :id="currentFormDataId" :key="componentKey"></component>
    <div slot="footer" class="uk-text-right">
      <vk-button class="uk-margin-small-right" @click="showed = false">Закрыть</vk-button>
    </div>
	</vk-modal> -->
  <b-modal :active.sync="showed" has-modal-card :can-cancel="['x']">
    <div class="card">
      <component :is="сurrentForm" :payload="currentFormData" :id="currentFormDataId" :key="componentKey" :title="title"></component>
    </div>
  </b-modal>
</template>

<script>

import { EventBus } from '@/utils'

export default {
  name: 'AdminModal',
  components: {
    ChartMap: () => import('./ChartMap'),
    ProductForm: () => import('./product/form'),
    UploadForm: () => import('./file/form'),
    UserForm: () => import('./user/form'),
    UserPasswordForm: () => import('./user/password'),
    ClientForm: () => import('./client/form'),
    ClientPasswordForm: () => import('./client/password'),
    RoleForm: () => import('./role/form'),
    PermissionForm: () => import('./permission/form'),
    CompanyForm: () => import('./company/form'),
    OrderForm: () => import('./order/form'),
    GroupForm: () => import('./settings/group/form'),
    TypeForm: () => import('./settings/type/form'),
    StateForm: () => import('./settings/state/form'),
    CategoryForm: () => import('./settings/category/form'),
    ReviewForm: () => import('./review/form'),
    LocaleForm: () => import('./settings/tutorial/form')
  },
  props: {
    //
  },
  data: function () {
    return {
      loading: true,
      showed: false,
      action: null,
      title: "Карта ЭНК",
      сurrentForm: null,
      currentFormData: null,
      currentFormDataId: null,
      componentKey: null
    }
  },
  created: function() {
    //
  },
  computed: {
    //
  },
  beforeMount: function(){
    //
  },
  mounted: function(){
    let $this = this
    EventBus.$on('hideModal', function () {
      $this.showed = false
    })

    EventBus.$on('successUploadFile', () => {
      $this.$toast.open({
        message: $this.$i18n.t('admin.file_upload_success'),
        type: 'is-success',
        position: 'is-bottom'
      })
    })

    let SUCCESS_CREATE = [
      'successCreateRole',
      'successCreatePermission',
      'successCreateUser',
      'successCreateClient',
      'successCreateProduct',
      'successCreateCompany',
      'successCreateOrder',
      'successCreateReview',
      "successUpload"
    ]

    let SUCCESS_UPDATE = [
      'successUpdateRole',
      'successUpdatePermission',
      'successUpdateUser',
      'successUpdateClient',
      'successUpdateProduct',
      'successUpdateCompany',
      'successUpdateOrder',
      'successUpdateReview',
      'successUpdateLocale',
      'successChangePasswordClient',
      'successChangePasswordUser'
    ]

    let SUCCESS = []
    SUCCESS.push.apply(SUCCESS, SUCCESS_CREATE)
    SUCCESS.push.apply(SUCCESS, SUCCESS_UPDATE)
    
    EventBus.$on(SUCCESS, () => {
      console.log("Need close modal.")
      $this.showed = false
    })
    
  },
  methods: {
    show(action, data){
      let $this = this
      $this.componentKey += 1;
      $this.showed = true

      if (action === "chart.view"){
        $this.сurrentForm = 'ChartMap'
        $this.title = 'Просмотр ЭНК'
        $this.currentFormData = data
        $this.currentFormDataId = null
      }
      if (action === "user.add" || action === "user.edit" || action === "user.password"){
        $this.сurrentForm = 'UserForm'
        $this.currentFormData = undefined
        if (action === "user.add"){
          $this.title = 'Добавление пользователя'
        }
        if (action === "user.edit"){
          $this.title = 'Редактирование пользователя'
          $this.currentFormDataId = data
        }
        if (action === "user.password"){
          $this.сurrentForm = 'UserPasswordForm'
          $this.title = 'Смена пароля пользователя'
          $this.currentFormDataId = data
        }
      }
      if (action === "role.add" || action === "role.edit"){
        $this.сurrentForm = 'RoleForm'
        $this.currentFormData = undefined
        if (action === "role.add"){
          $this.title = 'Добавление роли'
          $this.currentFormDataId = undefined
        }
        if (action === "role.edit"){
          $this.title = 'Редактирование роли'
          $this.currentFormDataId = data
        }
      }
      if (action === "permission.add" || action === "permission.edit"){
        $this.сurrentForm = 'PermissionForm'
        $this.currentFormData = undefined
        if (action === "permission.add"){
          $this.title = 'Добавление полномочий'
          $this.currentFormDataId = undefined
        }
        if (action === "permission.edit"){
          $this.title = 'Редактирование полномочий'
          $this.currentFormDataId = data
        }
      }
      if (action === "client.add" || action === "client.edit" || action === "client.password"){
        $this.сurrentForm = 'ClientForm'
        $this.currentFormData = undefined
        if (action === "client.add"){
          $this.title = 'Добавление клиента'
          $this.currentFormDataId = undefined
        }
        if (action === "client.edit"){
          $this.title = 'Редактирование клиента'
          $this.currentFormDataId = data
        }
        if (action === "client.password"){
          $this.сurrentForm = 'ClientPasswordForm'
          $this.title = 'Смена пароля клиента'
          $this.currentFormDataId = data
        }
      }
      if (action === "product.add" || action === "product.edit"){
        $this.сurrentForm = 'ProductForm'
        $this.currentFormData = undefined
        if (action === "product.add"){
          $this.title = 'Добавление ЭНК'
          $this.currentFormDataId = undefined
        }
        if (action === "product.edit"){
          $this.title = 'Редактирование ЭНК'
          $this.currentFormDataId = data
        }
      }
      if (action === "company.add" || action === "company.edit"){
        $this.сurrentForm = 'CompanyForm'
        $this.currentFormData = undefined
        if (action === "company.add"){
          $this.title = 'Добавление компании/огранизации'
          $this.currentFormDataId = undefined
        }
        if (action === "company.edit"){
          $this.title = 'Редактирование компании/огранизации'
          $this.currentFormDataId = data
        }
      }
      if (action === "order.add" || action === "order.edit"){
        $this.сurrentForm = 'OrderForm'
        $this.currentFormData = undefined
        if (action === "order.add"){
          $this.title = 'Добавление заказа'
          $this.currentFormDataId = undefined
        }
        if (action === "order.edit"){
          $this.title = 'Редактирование заказа'
          $this.currentFormDataId = data
        }
      }
      if (action === "group.add" || action === "group.edit"){
        $this.сurrentForm = 'GroupForm'
        $this.currentFormData = undefined
        if (action === "group.add"){
          $this.title = 'Добавление типа/категории ЭНК'
          $this.currentFormDataId = undefined
        }
        if (action === "group.edit"){
          $this.title = 'Редактирование типа/категории ЭНК'
          $this.currentFormDataId = data
        }
      }
      if (action === "type.add" || action === "type.edit"){
        $this.сurrentForm = 'TypeForm'
        $this.currentFormData = undefined
        if (action === "type.add"){
          $this.title = 'Добавление типа ЭНК'
          $this.currentFormDataId = undefined
        }
        if (action === "type.edit"){
          $this.title = 'Редактирование типа ЭНК'
          $this.currentFormDataId = data
        }
      } 
      if (action === "state.add" || action === "state.edit"){
        $this.сurrentForm = 'StateForm'
        $this.currentFormData = undefined
        if (action === "state.add"){
          $this.title = 'Добавление состояния заказа'
          $this.currentFormDataId = undefined
        }
        if (action === "state.edit"){
          $this.title = 'Редактирование состояния заказа'
          $this.currentFormDataId = data
        }
      }
      if (action === "category.add" || action === "category.edit"){
        $this.сurrentForm = 'CategoryForm'
        $this.currentFormData = undefined
        if (action === "category.add"){
          $this.title = 'Добавление категории клиента'
          $this.currentFormDataId = undefined
        }
        if (action === "category.edit"){
          $this.title = 'Редактирование категории клиента'
          $this.currentFormDataId = data
        }
      }
      if (action === "review.add" || action === "review.edit"){
        $this.сurrentForm = 'ReviewForm'
        $this.currentFormData = undefined
        if (action === "review.add"){
          $this.title = 'Добавление отзыва'
          $this.currentFormDataId = undefined
        }
        if (action === "review.edit"){
          $this.title = 'Редактирование отзыва'
          $this.currentFormDataId = data
        }
      }
      if (action === "locale.add" || action === "locale.edit"){
        $this.сurrentForm = 'LocaleForm'
        $this.currentFormData = undefined
        if (action === "locale.add"){
          $this.title = 'Добавление локализации'
          $this.currentFormDataId = undefined
        }
        if (action === "locale.edit"){
          $this.title = 'Редактирование локализации'
          $this.currentFormDataId = data
        }
      }
      if (action === "file.upload"){
        $this.сurrentForm = 'UploadForm'
        $this.title = 'Загрузка файла'
        $this.currentFormData = undefined
        $this.currentFormDataId = undefined
      }
    }
  }
}
</script>

<style scoped>
</style>